import { getContext } from '@fiverr-private/fiverr_context';
import { Member } from '../types';

export const findCurrentUser = (members?: Member[]) => {
    const { userId } = getContext();
    return members?.find((member) => Number(member.userId) === Number(userId));
};

export const findAdminMember = (members?: Member[]) =>
    members?.find((member) => member.role === 'admin' && member.status === 'active');
